<div #anchor class="autocomplete-container" tamDropDownOutside (clickOutside)="onClickOutside($event)"
    (mouseenter)="boxHoverOn()" (mouseleave)="boxMouseOut()">
    <smart-icon class="map-expand" name="map-expand" size="32" (click)="changeBoxStatus()" *ngIf="!isBoxShow">
    </smart-icon>
    <smart-icon class="map-collapse" name="map-collapse" size="32" (click)="changeBoxStatus()"
        *ngIf="isBoxShow && isBoxHoverOn &&config.isFromMap">
    </smart-icon>
    <div class="outer-box"
        [ngClass]="{'isBoxShow': isBoxShow,'map-input-border':isFocus,'contact-address-autocomplete':!config.isFromMap}"
        [style.visibility]="isOuterBoxShow? 'visible': 'hidden'">
        <div class="inner-box">
            <input class="textInput common-input" [ngClass]="{'contact-address-input':!config.isFromMap}" type="text"
                placeholder="Search Google Maps" [(ngModel)]="userInput" (keydown.enter)="searchDirectly()"
                (focus)="showPopup($event)" (keyup)="keyUpHandler()" class="textInput">
            <kendo-popup class="popup" [anchor]="anchor" [style.visibility]="isPopUpShow? 'visible': 'hidden'"
                [ngClass]="{'address-popup-position':config.isShowInMSAddin}">
                <div class="dropdown" *ngIf="predictionArray && predictionArray.length > 0">
                    <a class="dropdown-content" *ngFor="let prediction of predictionArray">
                        <div class="contact-info" (click)="predictionSelected(prediction)">
                            <div class="contactName" *ngIf="prediction.contact && prediction.contact.name">
                                {{prediction.contact.name}}<span *ngIf="prediction.selectedAddressType"
                                    class="selectedAddress">({{prediction.selectedAddressType}})</span></div>
                            <div [title]="config.isShowInMSAddin?'':prediction.selectedAddress" class="selectedAddress">
                                {{prediction.selectedAddress}}</div>
                        </div>
                        <div class="icon-direction" (click)="directToMapTrip(prediction)" *ngIf='prediction.contact'>
                            <smart-icon class="direction" name="direction" size="20" *ngIf="config.isFromMap">
                            </smart-icon>
                        </div>
                    </a>
                </div>
            </kendo-popup>
            <smart-icon class="search" name="search" size="20" (click)="searchDirectly()"
                *ngIf="isIconShow&&config.isFromMap">
            </smart-icon>
            <div class="split" *ngIf="isIconShow&&config.isFromMap">
            </div>
            <smart-icon class="close" name="close" size="20" (click)="clearInput()" *ngIf="isIconShow">
            </smart-icon>

        </div>
        <div *ngIf="canShowDetail && isItemDetailShow&&config.isFromMap" class="item-detail map-border">
            <div class="address-info">
                <div>
                    <div>{{userInput}}</div>
                    <span> {{selectedMapContact.selectedAddress}}</span>
                </div>
                <smart-icon class="direction" name="direction" (click)="directToMapTrip()" size="20">
                </smart-icon>
            </div>
            <div class="icons">
                <span class="search-nearby" (click)="clickSearchNearby()">Search nearby</span>
            </div>
        </div>
    </div>
</div>